import { render, staticRenderFns } from "./AdminTemplate.vue?vue&type=template&id=03bf78a2&scoped=true&"
import script from "./AdminTemplate.vue?vue&type=script&lang=js&"
export * from "./AdminTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf78a2",
  null
  
)

export default component.exports